/* @ngInject */
export default class EmulatorFilterController {
    constructor($scope, currentFilter, onUpdate, onClose) {
        this.$scope = $scope;
        this.selectedValue = currentFilter || 'ONLY_NON_EMULATORS'; // Default to 'ONLY_NON_EMULATORS' if no filter is set
        this.onUpdate = onUpdate;
        this.onClose = onClose;
    }

    $onInit() {
        // Controller initialized with selectedValue from parent
    }

    clear() {
        this.selectedValue = null;
        this.apply();
    }

    apply() {
        this.onUpdate(this.selectedValue);
        this.onClose();
    }
}

